import type { Entry } from "@/shared/types/entries";
import type { GroupMode } from "@/v2/components/SortPopover";
import { parseEntryDate } from "@/v2/lib/dates";
import { getEntryEndHour } from "./time";

function formatHourLabel(hour: number): string {
	const period = hour >= 12 ? "PM" : "AM";
	const displayHour = hour % 12 || 12;
	return `${displayHour}:00 ${period}`;
}

function formatRelativeDate(date: Date): string {
	const now = new Date();
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	const target = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	const diffDays = Math.round((today.getTime() - target.getTime()) / 86400000);

	if (diffDays === 0) return "Today";
	if (diffDays === 1) return "Yesterday";
	if (diffDays === -1) return "Tomorrow";

	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];
	const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
	const dayName = days[target.getDay()];
	const month = months[target.getMonth()];
	const day = target.getDate();

	if (diffDays > 1 && diffDays < 7) return `${dayName}, ${month} ${day}`;
	if (target.getFullYear() !== now.getFullYear()) {
		return `${month} ${day}, ${target.getFullYear()}`;
	}
	return `${dayName}, ${month} ${day}`;
}

export function groupingForMode(group: GroupMode): string[] {
	switch (group) {
		case "hour":
			return ["groupHour"];
		case "matter":
			return ["matter"];
		case "application":
			return ["application"];
		case "none":
			return [];
	}
}

export function getEntryHourGroupLabel(
	entry: Entry,
	isMultiDate: boolean,
): string {
	const hour = getEntryEndHour(entry.end_time);
	const hourLabel = hour === null ? "Unknown" : formatHourLabel(hour);
	if (isMultiDate && entry.date) {
		return `${formatRelativeDate(parseEntryDate(entry.date))} · ${hourLabel}`;
	}
	return hourLabel;
}
